export const UPGRADE_BANNER_TYPES = {
  LIMIT_PACK_BANNER: 'LIMIT_PACK_BANNER',
  REMOVE_BRANDING_BANNER: 'REMOVE_BRANDING_BANNER',
  USAGE_LIMIT_BANNER: 'USAGE_LIMIT_BANNER'
};